import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-business-contact-dialog',
  templateUrl: './business-contact-dialog.component.html',
  styleUrls: ['./business-contact-dialog.component.scss'],
})
export class BusinessContactDialogComponent {
  list = [
    {},
    {},
    {
      text1: '批量采购',
      text2: '我们诚挚欢迎您与我们合作！',
      text3:
        '无论您是企业采购商还是批发销售商，我们都将为您具有竞争力的价格以及高效的服务。',
      text4:
        '如果您有批发需求，请扫描下方二维码，并告诉我们您想购买的服务与数量，我们将为您提供专属优惠和定制方案！',
      text5: '感谢您的信任与选择，期待与您长期合作！',
    },
    {
      text1: '定制化合作提案',
      text2: '我们诚挚欢迎您与我们合作！',
      text3:
        '无论您有独特的跨界合作构想，还是尚未被定义的创新方向，我们都愿以开放态度与您携手探索。您的创意与需求，是我们拓展价值的契机。',
      text4:
        '请扫描下方二维码，简要描述您的合作方向或具体想法，专员会与您进一步展开合作细节感谢您的信任与灵感，期待与您携手探索更多机遇！',
      text5: '感谢您的信任与灵感，期待与您携手探索更多机遇！',
    },
  ];

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}
}
